<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="bk">
<h1 class="bk"><a class="page" id="pii"></a><a class="page" id="piii"></a>Pain, Pleasure, and the Greater Good</h1>
<h1 class="bk1">From the Panopticon to the Skinner Box and Beyond</h1>
<p class="bkau">CATHY GERE</p>
<p class="bkpub">The University of Chicago Press</p>
<p class="bkpub1">Chicago and London</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-gere-0003.vue?e77b50bc